import { fromJS } from 'immutable'
import moment from 'moment'
import { recentDate, fullName, companyName, jobTitle, email, avatar, pastDate } from 'app/utils/faker'

export const demoFunnelMetrics = fromJS({
  'funnelMetrics': [
    {
      'displayName': 'Sent',
      'key': 'ENGAGED',
      'metric': {
        'value': 100,
        'type': 'FIXED'
      }
    },
    {
      'displayName': 'Conversations',
      'key': 'CONVERSATIONS',
      'metric': {
        'value': 75,
        'type': 'FIXED'
      }
    },
    {
      'displayName': 'Goals Reached',
      'key': 'GOAL_REACHED',
      'metric': {
        'value': 30,
        'type': 'FIXED'
      }
    },
    {
      'displayName': 'CQLs',
      'key': 'CQL',
      'metric': {
        'value': 40,
        'type': 'FIXED'
      }
    },
    {
      'displayName': 'Meetings Booked',
      'key': 'MEETINGS_BOOKED',
      'metric': {
        'value': 20,
        'type': 'FIXED'
      }
    }
  ],
  'otherMetrics': [
    {
      'displayName': 'Emails Captured',
      'key': 'LEADS_CAPTURED',
      'metric': {
        'value': 0,
        'type': 'FIXED'
      }
    },
    {
      'displayName': 'Delivered',
      'key': 'DELIVERED',
      'metric': {
        'value': 0,
        'type': 'FIXED'
      }
    }
  ]
})

export const makeFakePerson = function(id) {
  return {
    id: id,
    name: fullName(),
    companyName: companyName(),
    jobTitle: jobTitle(),
    email: email(),
    leadStage: 'LeadBot Qualified',
    avatarUrl: avatar(),
    conversationDate: moment(recentDate()).format('YYYY-MM-DD'),
    conversationId: id,
    inboxId: 41,
    attributes: {
      start_date: pastDate(),
      last_active: recentDate(),
    }
  }
}


export const makeFakePeople = function(numPeople) {
  return _.range(numPeople).map(makeFakePerson)
}

export const makeFakePeopleWithIds = function(numPeople, ids) {
  return _.forEach(ids).map(makeFakePerson)
}


export const demoContacts = {
  "results": makeFakePeople(20),
  "totalMatching": 20
}

export const demoPeople = makeFakePeople(100)

export const demoPeopleChatEngaged = {
  people: demoPeople,
  total: 100
}

export const demoGoalLeads = { 'leadStages':{},'other':{ 'no_goal':{ 'value':3,'type':'FIXED' }},'total':14 }


const generateFakeHistogram = function(date) {
  return _.range(date.date()).map(i => {
    return {
      date: {
        value: moment(date).subtract(i, 'days').format('YYYY-MM-DD'),
        type: 'DATE'
      },
      'GOAL_REACHED': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'CONVERSATIONS': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'ENGAGED': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'MEETINGS_BOOKED': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'CQL': {
        'value': _.random(5),
        'type': 'FIXED'
      }
    }
  }).reverse()
}

export const makeFakeChatHistogram = function() {
  return fromJS({
    current: generateFakeHistogram(moment()),
    previous: generateFakeHistogram(moment().subtract(1, 'months').endOf('month')),
    metadata: {
      'GOAL_REACHED': 'Goals Reached',
      'CONVERSATIONS': 'Conversations',
      'MEETINGS_BOOKED': 'Meetings Booked',
      'ENGAGED': 'Sent',
      'CQL': 'CQLs'
    }
  })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/reports/demodata.js